import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgIconOutlineWe = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#000"
      d="M13.01 31.192v-3.75q0-.638.44-1.093a1.5 1.5 0 0 1 1.06-.474h3.265q.396 0 .76.198.363.198.619.544a5.1 5.1 0 0 0 1.893 1.668 5.3 5.3 0 0 0 2.453.59q1.305 0 2.458-.59a5.3 5.3 0 0 0 1.923-1.668q.246-.346.597-.544t.747-.198h3.265a1.5 1.5 0 0 1 1.07.474q.44.455.44 1.093v3.75h-6.134v-2.86a6.5 6.5 0 0 1-2 1.237 6.4 6.4 0 0 1-2.366.44 6.4 6.4 0 0 1-2.343-.435 6.6 6.6 0 0 1-2.013-1.232v2.85zm10.49-4.067a3.5 3.5 0 0 1-1.625-.398 3.4 3.4 0 0 1-1.27-1.104 3.55 3.55 0 0 0-1.953-1.371q.763-.654 2.188-.987t2.66-.332q1.244 0 2.672.332t2.201.987q-.583.163-1.082.509a3.4 3.4 0 0 0-.862.862 3.4 3.4 0 0 1-1.274 1.104 3.6 3.6 0 0 1-1.655.398m-7.711-3.183q-1.05 0-1.808-.76-.76-.759-.76-1.807 0-1.073.76-1.82a2.5 2.5 0 0 1 1.808-.747q1.073 0 1.82.747t.747 1.82a2.5 2.5 0 0 1-.747 1.808 2.46 2.46 0 0 1-1.82.76m15.423 0q-1.05 0-1.808-.76-.76-.759-.76-1.807 0-1.073.76-1.82a2.5 2.5 0 0 1 1.808-.747q1.073 0 1.82.747t.747 1.82a2.5 2.5 0 0 1-.747 1.808 2.46 2.46 0 0 1-1.82.76m-7.712-3q-1.048 0-1.808-.76-.76-.759-.76-1.807 0-1.073.76-1.82a2.5 2.5 0 0 1 1.808-.747q1.073 0 1.82.747t.747 1.82a2.5 2.5 0 0 1-.747 1.808 2.46 2.46 0 0 1-1.82.76"
    />
    <rect
      width={46.333}
      height={46.333}
      x={0.333}
      y={0.333}
      stroke="#32353B"
      strokeOpacity={0.2}
      strokeWidth={0.667}
      rx={11.667}
    />
  </svg>
);

export default SvgIconOutlineWe;
